import styled, { css } from 'styled-components';
import breakpoints from '../../styles/breakpoints';
import { px, pxToRem, rem } from '../../utils';
import { FontWeight } from '../Text/Text.constants';
function setFontSizeToRem(htmlTagName, fractionPartFontSize, theme) {
  return rem(pxToRem(fractionPartFontSize[htmlTagName], theme));
}
function setFontWeight(isFractionPartBolded, tagName, theme) {
  return isFractionPartBolded ? FontWeight.BOLD : theme.Typography.TEXT_TYPE_TO_FONT_WEIGHT[tagName];
}
export const AmountWrapper = styled.span.withConfig({
  componentId: "ds__sc-bpnyb1-0"
})(["position:relative;color:", ";font-weight:inherit;font-size:inherit;letter-spacing:inherit;white-space:nowrap;", ""], _ref => {
  let {
    isValueColorized,
    theme
  } = _ref;
  return isValueColorized ? theme.Amount.colorized.color : 'inherit';
}, _ref2 => {
  let {
    isLineThrough
  } = _ref2;
  return isLineThrough && css(["&:after{content:'';left:0;right:0;top:50%;border-bottom:", ";margin-top:calc(-0.1em / 2 * -1);position:absolute;}"], _ref3 => {
    let {
      theme
    } = _ref3;
    return `0.1em solid ${theme.Main.color}`;
  });
});
export const FractionPart = styled.span.withConfig({
  componentId: "ds__sc-bpnyb1-1"
})(["font-weight:", ";font-size:", ";font-style:normal;letter-spacing:0;@media screen and (max-width:", "){font-size:", ";}"], _ref4 => {
  let {
    isFractionPartBolded,
    typographyVariant,
    theme
  } = _ref4;
  return setFontWeight(isFractionPartBolded, typographyVariant, theme);
}, _ref5 => {
  let {
    isFractionPartResized,
    typographyVariant,
    theme
  } = _ref5;
  return isFractionPartResized ? setFontSizeToRem(Array.isArray(typographyVariant) ? typographyVariant[1] : typographyVariant, theme.Typography.AMOUNT_FRACTION_PART_FONT_SIZE.desktop, theme) : 'inherit';
}, px(breakpoints.mobileMax), _ref6 => {
  let {
    isFractionPartResized,
    typographyVariant,
    theme
  } = _ref6;
  return isFractionPartResized ? setFontSizeToRem(Array.isArray(typographyVariant) ? typographyVariant[0] : typographyVariant, theme.Typography.AMOUNT_FRACTION_PART_FONT_SIZE.mobile, theme) : 'inherit';
});
export const CurrencySymbol = styled.span.withConfig({
  componentId: "ds__sc-bpnyb1-2"
})(["display:inline;padding-left:2px;font-weight:", ";font-size:", ";text-transform:", ";@media screen and (max-width:", "){font-size:", ";}"], _ref7 => {
  let {
    isFractionPartBolded,
    typographyVariant,
    theme
  } = _ref7;
  return setFontWeight(isFractionPartBolded, typographyVariant, theme);
}, _ref8 => {
  let {
    isFractionPartResized,
    isCurrencyPartResized,
    typographyVariant,
    theme
  } = _ref8;
  return isCurrencyPartResized ? 'inherit' : isFractionPartResized ? setFontSizeToRem(Array.isArray(typographyVariant) ? typographyVariant[1] : typographyVariant, theme.Typography.AMOUNT_FRACTION_PART_FONT_SIZE.desktop, theme) : 'inherit';
}, _ref9 => {
  let {
    isCurrencyPartResized
  } = _ref9;
  return isCurrencyPartResized ? 'uppercase' : '';
}, px(breakpoints.mobileMax), _ref10 => {
  let {
    isFractionPartResized,
    isCurrencyPartResized,
    typographyVariant,
    theme
  } = _ref10;
  return isCurrencyPartResized ? 'inherit' : isFractionPartResized ? setFontSizeToRem(Array.isArray(typographyVariant) ? typographyVariant[0] : typographyVariant, theme.Typography.AMOUNT_FRACTION_PART_FONT_SIZE.mobile, theme) : 'inherit';
});